import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/cn.js';
const buttonVariants = cva('inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-sm text-sm font-medium transition-colors duration-150 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0', {
    variants: {
        variant: {
            default: 'bg-[var(--color-ink)] text-[var(--color-canvas)] hover:bg-[var(--color-accent)]',
            accent: 'bg-[var(--color-accent)] text-[var(--color-canvas)] hover:bg-[var(--color-accent-bright)]',
            outline: 'border border-[var(--color-border)] bg-transparent text-[var(--color-ink)] hover:bg-[var(--color-accent-softer)]',
            ghost: 'text-[var(--color-ink-secondary)] hover:bg-[var(--color-accent-softer)] hover:text-[var(--color-ink)]',
            destructive: 'bg-[var(--color-critical)] text-[var(--color-canvas)] hover:bg-[var(--color-critical)]/90',
            link: 'text-[var(--color-accent)] underline-offset-4 hover:underline',
        },
        size: {
            default: 'h-9 px-4 py-2',
            sm: 'h-8 rounded-xs px-3 text-xs',
            lg: 'h-10 rounded-sm px-6',
            icon: 'h-9 w-9',
        },
    },
    defaultVariants: { variant: 'default', size: 'default' },
});
export const Button = forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (_jsx(Comp, { className: cn(buttonVariants({ variant, size, className })), ref: ref, ...props }));
});
Button.displayName = 'Button';
export { buttonVariants };
